var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"margin-top":"60px"}},[_c('strong',[_vm._v(_vm._s(_vm.message))]),_c('Loader',{attrs:{"dialog-loader":_vm.dialogLoader,"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }